import { useQuery } from '@tanstack/react-query';
import { MessageWithObservability } from '../../../types';
import { createInvestigationService } from '../../investigation/services/investigationService';
import { useAuth } from '../../auth/context/AuthContext';
import { chatMessageKeys, mapConversationToMessages } from './chatMessageMapping';

// Owns the conversation message list as query-cache state (ADR-0049). Loads
// history for the selected investigation; the streaming (user message) and
// websocket (assistant message) hooks append to this same cache entry with
// setQueryData rather than invalidating — invalidating would drop the streamed
// turns that are not yet persisted server-side.
export function useConversationMessages(customerId?: string, sessionId?: string) {
  const { idToken } = useAuth();

  return useQuery<MessageWithObservability[]>({
    queryKey: chatMessageKeys.list(customerId, sessionId),
    queryFn: async () => {
      const service = createInvestigationService(idToken!);
      const conversation = await service.getConversationHistory(customerId!, sessionId!);
      return mapConversationToMessages(conversation, sessionId!);
    },
    enabled: !!customerId && !!sessionId && !!idToken,
  });
}
